@if (!textComponent) {
  <mat-card (click)="clickRelation()">
    <mat-card-header>
      <mat-card-title>{{ targetTermName }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <pub-card-content [conceptId]="targetConceptId" [termId]="targetTermId" [imageFields]="imageFields">
      </pub-card-content>
    </mat-card-content>
  </mat-card>
}


@if (textComponent) {
  <a (click)="clickRelation()">
    <span>{{ relation.type }}</span>
    <mat-icon class="rel-font-icon"
              [matTooltip]="getTooltipForRelAttr(relation.attribute, isReversed)">{{ getIconForRelAttr(relation.attribute, isReversed) }}</mat-icon>
    <span [attr.title]="relation.text">{{ targetTermName }}</span>
  </a>
}
